module.exports = __webpack_public_path__ + "434a2945c94e7ec1a6b1089319123f1f.glb";